import { sentenceCase } from 'change-case';
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
// material
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Card,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
// components
import { Document, pdfjs, Page as Pages } from 'react-pdf';

import BrudCrumbs from '../../components/BreadCrumbs';
import Label from '../../components/Label';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserMoreMenu } from '../../components/_dashboard/user';
//
import { StyledTableCell, StyledTableRow } from './Styling';
import aadharFrontDummy from './aadharFrontDummy.jpg';

import { NOT_AVAILABLE } from './Constants';
import Loader from './Loader';
import ApiErrorMessage from './ApiErrorMessage';
import PrintDownloadToolbar from './PrintDownloadToolbar';
import { CommonApiforJourney } from '../services/RecommendationApi';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'documentList', label: 'List of Document', alignRight: false },
  { id: 'ApplicantType', label: 'Applicant Type', alignRight: false },
  { id: 'statusLeads', label: 'status', alignRight: false },
  { id: 'verifiedStatus', label: 'Verified Status', alignRight: false },
  { id: '', label: 'ACTION' }
];

/**
 * Represents a book.
 * @constructor
 * @param {string} title - The title of the book.
 * @param {string} author - The author of the book.
 */
export default function PrintDownload() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const [documentPreview, setDocumentPreview] = useState(false);

  const [openLoader, setOpenLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [openApiError, setOpenApiError] = useState(false);
  const [printDownloadList, setPrintDownloadList] = useState([]);
  const [filterState, setFilterState] = useState({
    product: ' ',
    productId: null,
    productArray: [],
    city: null,
    cityId: null,
    cityArray: [],
    status: ' ',
    statusId: null,
    statusArray: [],
    employmentType: ' ',
    employmentTypeId: null,
    employmentTypeArray: []
  });
  const [docPrevFlag, setDocPrevFlag] = useState({
    flag: false,
    srcPath: null,
    imgaltTag: null,
    contentType: null
  });
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const { LoginData } = useLoginSelector();

  useEffect(() => {
    let documentListItem = localStorage.getItem('allDocumentList');
    documentListItem = JSON.parse(documentListItem);
    if (documentListItem !== null) {
      setPrintDownloadList(documentListItem.documentList);
    }
  }, []);

  // console.log('printDownloadList', printDownloadList);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = printDownloadList.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleClick = (event, item) => {
    const selectedIndex = selected.indexOf(item);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const printDownloadApiFire = async (type, condition) => {
    let localSelectedItem = localStorage.getItem('leadDetails');
    localSelectedItem = JSON.parse(localSelectedItem);
    const companyIdObj = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId
    };
    let methodName = '';
    let endapiPath = '';
    const token = LoginData?.jwt;
    if (type === 'printDownload' && localSelectedItem !== null) {
      companyIdObj.applicationId = localSelectedItem?.leadesItem[0]?.applicationId;
      companyIdObj.documentDownloadDetailsRequestModels = condition;
      methodName = 'POST';
      endapiPath = 'file/downloadDocument';
    }
    printDownloadApiFireResponse(
      type,
      methodName,
      endapiPath,
      JSON.stringify(companyIdObj),
      token,
      ''
    );
  };

  const printDownloadApiFireResponse = async (
    type,
    method,
    endpoint,
    credentials,
    authToken,
    frmData
  ) => {
    setOpenLoader(true);
    const responseData = await CommonApiforJourney(
      method,
      endpoint,
      credentials,
      authToken,
      frmData
    );
    if (responseData.status === 'success' || responseData.action_status === 'success') {
      // console.log('responseDataresponseData', responseData);
    } else if (responseData.type === 'application/zip') {
      // console.log('responseDataresponseData', responseData);
      setOpenLoader(false);
      const blobData = URL.createObjectURL(responseData);
      if (type === 'printDownload') {
        window.location.assign(blobData);
      }
    } else {
      setOpenLoader(false);
      setOpenApiError(true);
      setErrorMessage('Something went wrong !');
    }
  };

  const docPrevHandler = (type, srcData) => {
    if (type === 'open') {
      const responseData = JSON.parse(srcData);
      // console.log('cccccccccc', responseData);
      setDocPrevFlag({
        flag: true,
        srcPath: responseData.src,
        imgaltTag: responseData.alt,
        contentType: responseData.contentType
      });
    } else {
      setDocPrevFlag({ flag: false, srcPath: null, imgaltTag: null, contentType: null });
    }
  };
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  const printDocument = (docItem) => {
    // console.log('dddd');
  };
  return (
    <Card>
      <PrintDownloadToolbar
        filterName={filterName}
        onFilterName={handleFilterByName}
        parent="print-download-leads"
        filterState={filterState}
        setFilterState={setFilterState}
        selected={selected}
        printDownloadApiFire={printDownloadApiFire}
        printDocument={printDocument}
      />

      <Scrollbar>
        <TableContainer sx={{ minWidth: 800, height: '70vh', overflow: 'auto' }}>
          <Table>
            <UserListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={printDownloadList.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
              onSelectAllClick={handleSelectAllClick}
              isCheckBox="true"
            />
            <TableBody>
              {printDownloadList.map((item, index) => {
                console.log(item);
                const isItemSelected = selected.indexOf(item) !== -1;
                return (
                  <StyledTableRow
                    hover
                    key={item.applicationId}
                    tabIndex={-1}
                    role="checkbox"
                    selected={isItemSelected}
                    aria-checked={isItemSelected}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isItemSelected}
                        onChange={(event) => handleClick(event, item)}
                      />
                    </TableCell>

                    <StyledTableCell align="left">
                      {item?.documentName !== null &&
                      item?.documentName !== '' &&
                      item?.documentName !== undefined
                        ? item?.documentName
                        : NOT_AVAILABLE}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {' '}
                      {item?.type !== null && item?.type !== '' && item?.type !== undefined
                        ? item?.type
                        : NOT_AVAILABLE}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {' '}
                      {item?.status !== null && item?.status !== '' && item?.status !== undefined
                        ? item?.status
                        : NOT_AVAILABLE}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {' '}
                      {item?.verifiedStatus !== null &&
                      item?.verifiedStatus !== '' &&
                      item?.verifiedStatus !== undefined
                        ? item?.verifiedStatus
                        : NOT_AVAILABLE}
                    </StyledTableCell>
                    {/* <StyledTableCell align="left">
                      <Label
                        variant="ghost"
                        color={
                          (item.statusLeads === 'U-Doc' && 'error') ||
                          (item.statusLeads === 'U-Log in' && 'error') ||
                          (item.statusLeads === 'Contacted' && 'success') ||
                          (item.statusLeads === 'Completed' && 'success') ||
                          (item.statusLeads === 'Submitted' && 'success') ||
                          'warning'
                        }
                      >
                        {sentenceCase(item.statusLeads)}
                      </Label>
                    </StyledTableCell>
                    <StyledTableCell align="left">{item.verifiedStatus}</StyledTableCell> */}

                    <StyledTableCell align="" width={60}>
                      <StyledTableCell align="" width={115}>
                        <UserMoreMenu
                          rowId={item}
                          parent="print-download-leads"
                          docPrevHandler={docPrevHandler}
                        />
                      </StyledTableCell>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
            {printDownloadList.length === 0 && (
              <TableBody>
                <TableRow>
                  <StyledTableCell align="center" colSpan={12} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </StyledTableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Scrollbar>
      <Dialog
        className="PopupBox"
        open={docPrevFlag.flag}
        onClose={() => docPrevHandler('close', '')}
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="popupHeading">
          <Typography variant="h6" className="popupTitle">
            {docPrevFlag.contentType === 'content'
              ? 'Document Size Error '
              : docPrevFlag.contentType === 'validation'
              ? 'Required Fields'
              : 'Document Preview'}
          </Typography>
          <IconButton onClick={() => docPrevHandler('close', '')} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers className="PopupContent">
          <DialogContentText>
            {docPrevFlag.contentType === 'content' || docPrevFlag.contentType === 'validation' ? (
              docPrevFlag.imgaltTag
            ) : docPrevFlag.contentType === 'application/pdf' ? (
              <Document
                file={docPrevFlag.srcPath}
                onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
              >
                <Pages pageNumber={pageNumber} />
              </Document>
            ) : (
              <img src={docPrevFlag.srcPath} alt={docPrevFlag.imgaltTag} />
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="mainBtn" onClick={() => docPrevHandler('close', '')}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Loader openLoader={openLoader} />
      <ApiErrorMessage
        openApiError={openApiError}
        setOpenApiError={setOpenApiError}
        errorMessage={errorMessage}
      />
    </Card>
  );
}
